import { useState } from "react";
import { toast } from "sonner";
import { AlertTriangle, Ban, Boxes, Play, Truck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { GlassCard } from "@/components/erp";
import api, { errMsg } from "@/lib/api";

const SECENEK = [
  ["durdur", "Üretimi durdur", Ban, "İş emri iptal edilir, stoka bir şey girmez"],
  ["stok_devam", "Stok için devam", Play, "Üretim sürer, bitince stoka girer"],
  ["uretileni_stoga", "Stoğa gireni bırak", Boxes, "Şu ana kadar stoğa giren kalır, kalan durur"],
  ["uretileni_gonder", "Üretileni müşteriye gönder", Truck, "Stoğa giren kısım için müşteriye yeni sipariş açılır"],
];

const Kart = ({ ie, onDone }) => {
  const [not, setNot] = useState("");
  const [busy, setBusy] = useState(false);
  const uretilen = ie.tamamlanan || 0;
  const ver = async (karar, ad) => {
    if (!window.confirm(`${ie.no}: "${ad}" kararı verilsin mi?`)) return;
    setBusy(true);
    try { await api.post(`/is-emirleri/${ie.id}/iptal-karari`, { karar, not }); toast.success(`${ie.no} için karar kaydedildi`); onDone(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl bg-white/[0.04] p-4 space-y-3" data-testid={`karar-${ie.no}`}>
      <div className="text-sm"><span className="font-mono">{ie.no}</span> · {ie.ad} · {ie.miktar} {ie.birim}
        <div className="text-xs text-muted-foreground mt-0.5">{ie.iptal_karari?.siparis_no} ({ie.iptal_karari?.cari_unvan}) {ie.iptal_karari?.isteyen} tarafından iptal edildi ·
          {uretilen > 0 ? ` şu ana kadar ${uretilen} ${ie.birim} stoğa girdi` : " henüz stoğa giren yok"}</div></div>
      <Input data-testid={`karar-not-${ie.no}`} placeholder="Not (isteğe bağlı)" value={not} onChange={(e) => setNot(e.target.value)} className="h-8 bg-white/5" />
      <div className="flex flex-wrap gap-2">
        {SECENEK.map(([k, ad, Icon, ipucu]) => (
          <button key={k} data-testid={`karar-${ie.no}-${k}`} title={ipucu} disabled={busy || (k.startsWith("uretileni") && !(uretilen > 0))} onClick={() => ver(k, ad)}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs bg-white/10 hover:bg-white/15 disabled:opacity-35"><Icon className="w-3.5 h-3.5" />{ad}</button>
        ))}
      </div>
    </div>
  );
};

export const IptalKararlari = ({ emirler, planlar, onDone }) => {
  const bekleyen = emirler.filter((e) => e.durum === "karar_bekliyor");
  if (!bekleyen.length) return null;
  return (
    <GlassCard className="p-5 mb-6 border border-amber-500/30 space-y-3" data-testid="iptal-kararlari">
      <div className="flex items-center gap-2 font-medium text-amber-200"><AlertTriangle className="w-4 h-4" />İptal edilen siparişlerin iş emirleri durduruldu — üretim şefi kararı bekleniyor ({bekleyen.length})</div>
      {planlar ? bekleyen.map((ie) => <Kart key={ie.id} ie={ie} onDone={onDone} />)
        : <p className="text-sm text-muted-foreground">{bekleyen.map((e) => e.no).join(", ")} — kararı üretim şefi verecek.</p>}
    </GlassCard>
  );
};
